module.exports = __webpack_public_path__ + "img/coverPicture.beeebfef.png";